<template>
   <AccountProfileField
      v-if="sexAtBirth"
      :title="field.label"
      :details="sexAtBirth"
      :fieldNotice="field.fieldNotice"
      data-cy="account-profile-sex"
   />
</template>
<script setup lang="ts">
import type { AccountProfileField } from "@/components/account/accountTypes";
import { useUserStore } from "@/stores/userStore";

const userStore = useUserStore();
const $t = useI18n().t;

// Props
// ------------------------------------
const props = defineProps<{
   field: AccountProfileField;
}>();

// Computed
// ------------------------------------
const sexAtBirth = computed(() => {
   switch (userStore.user?.sex) {
      case "female":
         return $t("user-data.sex_at_birth_options.female");
      case "male":
         return $t("user-data.sex_at_birth_options.male");
      case "intersex":
         return $t("user-data.sex_at_birth_options.intersex");
      default:
         return null;
   }
});
</script>
